import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  it: {
    translation: {
      nav: {
        home: 'Home',
        collections: 'Collezioni',
      shop: 'Negozio',
        about: 'Chi Siamo',
        cart: 'Carrello',
      },
      shop: {
        heroLabel: 'Fatto a Mano in Italia',
        heroTitle: 'Gioielli Artigianali Ispirati alla Fauna e all\'Outdoor',
        heroSubtitle: 'Esplora la nostra collezione completa di accessori in bronzo fatti a mano.',
        filters: 'Filtri',
        allCollections: 'Tutte le Collezioni',
        allTypes: 'Tutti i Tipi',
        showing: 'Visualizzazione di {{count}} prodotti',
        error: 'Errore nel caricamento dei prodotti',
        noProducts: 'Nessun prodotto trovato',
        removeFilters: 'Rimuovi filtri',
        collections: {
          mountain: 'Montagna',
          fauna: 'Fauna',
          equestrian: 'Equitazione',
        },
        types: {
          bracelet: 'Braccialetti',
          necklace: 'Collane',
          belt: 'Cinture',
          earrings: 'Orecchini',
          keychain: 'Portachiavi',
          cork: 'Tappi',
          pin: 'Spille',
        },
      },
      aboutPage: {
        heroLabel: 'La Nostra Storia',
        heroTitle: 'La Storia di Sampaoli: Arte in Bronzo Artigianale',
        heroSubtitle: 'Dalle splendide Colline Euganee, uniamo tradizione artigianale e passione per la natura in ogni creazione.',
        bioTitle: 'La Storia di Andrea Sampaoli',
        bio1: 'Andrea Sampaoli nasce a Padova come orafo e alpinista.',
        bio2: 'A Natale 2003 realizza, come regalo per i compagni di cordata, il suo primo articolo, la classica corda da arrampicata. Si rende conto poi che questa creazione potrebbe avere successo nel mondo della montagna.',
        bio3: 'Così nel 2004 abbandona definitivamente il laboratorio di oreficeria, per fondare Sampaoli Creazioni e aprire un nuovo laboratorio a Teolo. Proprio qui, nel cuore dei Colli Euganei, scopre il Bronzo come materiale ideale per le nuove creazioni, nate dalla passione per la montagna e per il suo mestiere.',
        bio4: 'Negli anni successivi, si dedica completamente alla creazione di questi gioielli, arricchendo le sue collezioni con nuovi articoli e ampliando la gamma a sempre più sport e passioni. Le sue creazioni, talvolta impreziosite con bagni galvanici e arricchite da smaltature colorate, mostrano la sua costante ricerca di perfezione e originalità.',
        bioQuote: '"La fedele riproduzione di ogni particolare fa di questi oggetti delle vere opere di realismo in miniatura."',
        founder: 'Fondatore',
        processLabel: 'Il Processo',
        processTitle: 'Dal Laboratorio al Mondo',
        processSubtitle: 'Ogni pezzo nasce dalla maestria artigianale italiana, unendo tecniche tradizionali a una cura meticolosa per i dettagli.',
        process: {
          design: { title: 'Progettazione', description: "Trae ispirazione dal mondo naturale, dalla fauna e dagli animali, e prende forma attraverso schizzi e idee." },
          casting: { title: 'Fusione del Bronzo', description: 'Metodi di fusione tradizionali per garantire la massima qualità in ogni dettaglio.' },
          finishing: { title: 'Rifinitura', description: 'Lucidato a mano e placcato con argento, oro o rodio per garantire durevolezza e bellezza.' },
          assembly: { title: 'Assemblaggio', description: 'Combinato con pelle pregiata e cordino artigianale per la creazione finale.' },
        },
        madeInItaly: 'Prodotto in Italia',
        madeInItalyDesc: 'Ogni pezzo è realizzato a mano nel nostro laboratorio a Teolo, nel cuore dei Colli Euganei.',
        hypoallergenic: 'Ipoallergenico',
        hypoallergenicDesc: 'Senza nichel e sicuro per le pelli sensibili.',
        qualityMaterials: 'Materiali di Qualità',
        qualityMaterialsDesc: 'Tappi sintetici e cuoio fiorentino.',
      },
      hero: {
        subtitle: 'Italian Creations',
        tagline: 'Creati per chi vive fuori.',
        elegantSubtitle: 'Gioielli in bronzo fatti a mano da Andrea Sampaoli.',
        cta: 'Scopri le collezioni',
        secondary: 'La Nostra Storia',
      },
      banner: {
        madeInItaly: 'Prodotto in Italia',
        madeInItalyDesc: 'Eseguito a mano nei Colli Euganei',
        hypoallergenic: 'Ipoallergenico',
        hypoallergenicDesc: 'Senza nichel, sicuro per pelli sensibili',
        globalShipping: 'Spedizione Globale',
        globalShippingDesc: 'Consegna sicura a casa tua',
      },
      announcement: {
        freeShipping: 'Spedizione gratuita per ordini sopra i 100€ (escluse cinture)',
        reseller: "Se sei un rivenditore contattaci all'indirizzo info@sampaolicreazioni.it",
      },
      values: {
        title: "L'Arte del Fatto a Mano",
        handmade: {
          title: 'Artigianato Autentico',
          description: 'Ogni pezzo è creato a mano con tecniche tradizionali italiane',
        },
        quality: {
          title: 'Qualità Italiana',
          description: 'Materiali pregiati selezionati dalle migliori botteghe',
        },
        passion: {
          title: 'Passione Genuina',
          description: 'Ispirato dalla bellezza delle Alpi e della natura',
        },
      },
      collections: {
        title: 'Le Nostre Collezioni',
        subtitle: 'Tre mondi, una passione',
        intro: 'Ogni collezione nasce dalla riproduzione fedele di oggetti reali, trasformati in gioielli artigianali in bronzo con cura per ogni dettaglio.',
        label: 'Collezione',
        mountain: {
          name: 'Collezione Montagna',
          description: 'Riproduzioni fedeli di attrezzatura alpinistica in bronzo: piccozze, rinvii, grigri, friends e moschettoni. Per chi porta la montagna sempre con sé.',
        },
        fauna: {
          name: 'Collezione Fauna',
          description: 'Cervi, caprioli, stambecchi, camosci, marmotte e rapaci: la fauna alpina riprodotta in ogni dettaglio. Gioielli per chi ama la natura e la vita selvatica.',
        },
        equestrian: {
          name: 'Collezione Equestre',
          description: 'Ferri di cavallo, staffe, speroni, morsi e stivali: il mondo equestre tra tradizione inglese e spirito western. Per cavalieri e amanti dei cavalli.',
          comingSoon: 'In Arrivo',
        },
        giftsHunters: {
          name: 'Idee Regalo per Cacciatori',
          description: 'Spille, cinture e portachiavi in bronzo dedicati alla fauna selvatica: il regalo ideale per cacciatori e amanti della natura.',
        },
        giftsClimbers: {
          name: 'Idee Regalo per Climber',
          description: 'Moschettoni, rinvii, piccozze e attrezzatura alpinistica in miniatura di bronzo: regali pensati per chi vive l\'arrampicata.',
        },
        carabinerNecklaces: {
          name: 'Collane Moschettone',
          description: 'Collane e ciondoli a forma di moschettone in bronzo fatti a mano: il simbolo dell\'arrampicata trasformato in gioiello.',
        },
        equestrianJewelry: {
          name: 'Gioielli Equestri',
          description: 'Collane cavallo, ferri di cavallo e simboli equestri in bronzo artigianale per cavalieri e amanti dei cavalli.',
        },
        viewCollection: 'Esplora',
      },
      featured: {
        title: 'I Più Amati',
        subtitle: 'Le creazioni preferite dai nostri clienti',
        swipeToSee: 'Scorri per vedere di più',
        bestSeller: 'Best Seller',
        artisanFavorites: 'Preferiti Artigianali',
        viewAll: 'Vedi Tutti i Prodotti',
        noProducts: 'Nessun prodotto disponibile',
      },
      reviews: {
        title: 'Cosa Dicono i Clienti',
        subtitle: 'Storie di chi ha scelto Sampaoli',
      },
      about: {
        previewTitle: 'La Nostra Storia',
        previewText: 'Da Teolo, nel cuore dei Colli Euganei, creiamo gioielli che raccontano storie di montagna, fauna e passione equestre.',
        cta: 'Scopri Chi Siamo',
        heroTitle: 'Chi Siamo',
        heroSubtitle: 'Una passione nata tra le montagne',
        storyTitle: 'La Storia di Sampaoli',
        storyText: "Sampaoli Creations nasce dalla passione per l'artigianato italiano e l'amore per la natura. Ogni pezzo che creiamo è un omaggio alle montagne che ci circondano, alla fauna selvatica che le abita e alla nobiltà del mondo equestre.",
        quote: '"Ogni creazione porta con sé un pezzo della nostra terra e del nostro cuore."',
        processTitle: 'Il Nostro Processo',
        process: {
          design: { title: 'Design', description: "Ogni pezzo inizia come un'idea ispirata dalla natura" },
          materials: { title: 'Materiali', description: 'Selezioniamo solo i migliori materiali italiani' },
          crafting: { title: 'Creazione', description: 'Lavoriamo a mano con tecniche tradizionali' },
          finishing: { title: 'Rifinitura', description: 'Ogni dettaglio è curato con precisione' },
        },
        valuesTitle: 'I Nostri Valori',
        location: 'Teolo, Padova, Italia',
      },
      social: {
        followUs: 'Seguici per ricevere novità e offerte esclusive',
      },
      chat: {
        needHelp: 'Hai bisogno di aiuto?',
        chatWithUs: 'Chatta con noi',
        hereToHelp: 'Siamo qui per aiutarti',
      },
      footer: {
        tagline: 'Creazioni artigianali italiane ispirate dalla natura',
        navigation: 'Navigazione',
        collections: 'Collezioni',
        contact: 'Contatti',
        newsletter: 'Newsletter',
        newsletterText: 'Iscriviti per ricevere novità e offerte esclusive',
        subscribe: 'Iscriviti',
        emailPlaceholder: 'La tua email',
        rights: 'Tutti i diritti riservati',
      },
      product: {
        notFound: 'Prodotto non trovato',
        notFoundDesc: 'Il prodotto che stai cercando non esiste.',
        variant: 'Variante',
        unavailable: 'Non Disponibile',
        addedToCart: 'Aggiunto al carrello',
        madeInItaly: 'Prodotto artigianalmente in Italia',
        hypoallergenic: 'Ipoallergenico - Senza nichel',
        globalShipping: 'Spedizione globale sicura',
        noImage: 'Nessuna immagine',
        relatedProducts: 'Potrebbe Piacerti Anche',
      },
      notFound: {
        title: 'Pagina non trovata',
        description: 'La pagina che stai cercando non esiste o è stata spostata.',
      },
      cart: {
        title: 'Carrello',
        empty: 'Il tuo carrello è vuoto',
        itemCount_one: '{{count}} articolo nel carrello',
        itemCount_other: '{{count}} articoli nel carrello',
        removeItem: 'Rimuovi dal carrello',
        decreaseQty: 'Diminuisci quantità',
        increaseQty: 'Aumenta quantità',
        creatingCheckout: 'Creazione checkout...',
        giftWrap: 'Confezione regalo',
        giftWrapPrice: '+€3,50',
        shippingAtCheckout: 'La spedizione verrà calcolata al checkout',
      },
      blog: {
        label: 'Il Nostro Blog',
        title: 'Storie di Chi Vive Fuori',
        subtitle: 'Montagna, caccia, cavalli e bronzo. Racconti per chi porta il proprio mondo con sé.',
        readMore: 'Leggi l\'articolo completo',
        backToBlog: 'Torna al Blog',
        relatedProducts: 'Prodotti Correlati',
      },
      common: {
        addToCart: 'Aggiungi al Carrello',
        viewProduct: 'Vedi Prodotto',
        price: 'Prezzo',
        quantity: 'Quantità',
        total: 'Totale',
        checkout: 'Procedi al Checkout',
        continueShopping: 'Continua lo Shopping',
        emptyCart: 'Il tuo carrello è vuoto',
        loading: 'Caricamento...',
      },
    },
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        collections: 'Collections',
      shop: 'Shop',
        about: 'About',
        cart: 'Cart',
      },
      shop: {
        heroLabel: 'Handmade in Italy',
        heroTitle: 'Handmade Wildlife and Outdoor Jewelry Collection',
        heroSubtitle: 'Explore our complete collection of handcrafted bronze accessories.',
        filters: 'Filters',
        allCollections: 'All Collections',
        allTypes: 'All Types',
        showing: 'Showing {{count}} products',
        error: 'Error loading products',
        noProducts: 'No products found',
        removeFilters: 'Remove filters',
        collections: {
          mountain: 'Mountain',
          fauna: 'Fauna',
          equestrian: 'Equestrian',
        },
        types: {
          bracelet: 'Bracelets',
          necklace: 'Necklaces',
          belt: 'Belts',
          earrings: 'Earrings',
          keychain: 'Keychains',
          cork: 'Corks',
          pin: 'Pins',
        },
      },
      aboutPage: {
        heroLabel: 'Our Story',
        heroTitle: 'The Story of Sampaoli: Handcrafted Bronze Art',
        heroSubtitle: 'From the beautiful Euganean Hills, we blend artisan tradition and passion for nature into every creation.',
        bioTitle: 'The Story of Andrea Sampaoli',
        bio1: 'Andrea Sampaoli was born in Padua as a goldsmith and mountaineer.',
        bio2: 'At Christmas 2003, as a gift for his climbing companions, he created his first piece—the classic climbing rope. He then realized this creation could be successful in the mountain world.',
        bio3: 'So in 2004, he definitively left the goldsmithing workshop to found Sampaoli Creazioni and open a new workshop in Teolo. Right here, in the heart of the Euganean Hills, he discovered Bronze as the ideal material for his new creations, born from his passion for mountains and his craft.',
        bio4: 'In the following years, he devoted himself entirely to creating these jewels, enriching his collections with new pieces and expanding the range to more sports and passions. His creations, sometimes enhanced with galvanic baths and enriched with colorful enamels, show his constant pursuit of perfection and originality.',
        bioQuote: '"The faithful reproduction of every detail makes these objects true works of miniature realism."',
        founder: 'Founder',
        processLabel: 'The Process',
        processTitle: 'From Workshop to World',
        processSubtitle: 'Each piece is born from Italian artisan mastery, blending traditional techniques with meticulous attention to detail.',
        process: {
          design: { title: 'Design', description: 'Drawing inspiration from the natural world, fauna and animals, taking shape through sketches and ideas.' },
          casting: { title: 'Bronze Casting', description: 'Traditional casting methods to ensure the highest quality in every detail.' },
          finishing: { title: 'Finishing', description: 'Hand-polished and plated with silver, gold, or rhodium for durability and beauty.' },
          assembly: { title: 'Assembly', description: 'Combined with premium leather and artisan cord for the final creation.' },
        },
        madeInItaly: 'Made in Italy',
        madeInItalyDesc: 'Every piece is handcrafted in our workshop in Teolo, in the heart of the Euganean Hills.',
        hypoallergenic: 'Hypoallergenic',
        hypoallergenicDesc: 'Nickel-free and safe for sensitive skin.',
        qualityMaterials: 'Quality Materials',
        qualityMaterialsDesc: 'Synthetic corks and Florentine leather.',
      },
      hero: {
        subtitle: 'Italian Creations',
        tagline: 'Created for those who live outside.',
        elegantSubtitle: 'Handcrafted bronze jewelry by Andrea Sampaoli.',
        cta: 'Explore the collections',
        secondary: 'Our Story',
      },
      banner: {
        madeInItaly: 'Made in Italy',
        madeInItalyDesc: 'Handcrafted in the Euganean Hills',
        hypoallergenic: 'Hypoallergenic',
        hypoallergenicDesc: 'Nickel-free, safe for sensitive skin',
        globalShipping: 'Global Shipping',
        globalShippingDesc: 'Safe delivery to your door',
      },
      announcement: {
        freeShipping: 'Free shipping on orders over €100 (belts excluded)',
        reseller: 'If you are a reseller, contact us at info@sampaolicreazioni.it',
      },
      values: {
        title: 'The Art of Handmade',
        handmade: {
          title: 'Authentic Craftsmanship',
          description: 'Each piece is handcrafted using traditional Italian techniques',
        },
        quality: {
          title: 'Italian Quality',
          description: 'Premium materials selected from the finest workshops',
        },
        passion: {
          title: 'Genuine Passion',
          description: 'Inspired by the beauty of the Alps and nature',
        },
      },
      collections: {
        title: 'Our Collections',
        subtitle: 'Three worlds, one passion',
        intro: 'Each collection is born from faithful reproductions of real objects, transformed into handcrafted bronze jewelry with care for every detail.',
        label: 'Collection',
        mountain: {
          name: 'Mountain Collection',
          description: 'Faithful bronze reproductions of climbing gear: ice axes, quickdraws, belay devices, cams, and carabiners. For those who carry the mountains with them.',
        },
        fauna: {
          name: 'Fauna Collection',
          description: 'Deer, roe deer, ibex, chamois, marmots, and birds of prey: alpine wildlife captured in every detail. Jewelry for nature and wildlife lovers.',
        },
        equestrian: {
          name: 'Equestrian Collection',
          description: 'Horseshoes, stirrups, spurs, bits, and boots: the equestrian world between English tradition and Western spirit. For riders and horse lovers.',
          comingSoon: 'Coming Soon',
        },
        giftsHunters: {
          name: 'Gifts for Hunters',
          description: 'Handmade bronze pins, belts and keychains inspired by wildlife — the perfect gift for hunters and nature lovers.',
        },
        giftsClimbers: {
          name: 'Gifts for Climbers',
          description: 'Miniature bronze carabiners, quickdraws, ice axes and climbing gear — gifts made for those who live to climb.',
        },
        carabinerNecklaces: {
          name: 'Carabiner Necklaces',
          description: 'Handmade bronze carabiner pendants and necklaces — climbing\'s most recognizable symbol, turned into jewelry.',
        },
        equestrianJewelry: {
          name: 'Equestrian Jewelry',
          description: 'Horse necklaces, horseshoes and bronze equestrian symbols, handmade for riders and horse lovers.',
        },
        viewCollection: 'Explore',
      },
      featured: {
        title: 'Best Sellers',
        subtitle: "Our customers' favorite creations",
        swipeToSee: 'Swipe to see more',
        bestSeller: 'Best Seller',
        artisanFavorites: 'Artisan Favorites',
        viewAll: 'View All Products',
        noProducts: 'No products available',
      },
      reviews: {
        title: 'What Customers Say',
        subtitle: 'Stories from those who chose Sampaoli',
      },
      about: {
        previewTitle: 'Our Story',
        previewText: 'From Teolo, in the heart of the Euganean Hills, we create jewelry that tells stories of mountains, wildlife, and equestrian passion.',
        cta: 'Learn More About Us',
        heroTitle: 'About Us',
        heroSubtitle: 'A passion born in the mountains',
        storyTitle: 'The Story of Sampaoli',
        storyText: 'Sampaoli Creations was born from a passion for Italian craftsmanship and love for nature. Every piece we create is a tribute to the mountains that surround us, the wildlife that inhabits them, and the nobility of the equestrian world.',
        quote: '"Every creation carries a piece of our land and our heart."',
        processTitle: 'Our Process',
        process: {
          design: { title: 'Design', description: 'Each piece starts as an idea inspired by nature' },
          materials: { title: 'Materials', description: 'We select only the finest Italian materials' },
          crafting: { title: 'Crafting', description: 'We work by hand with traditional techniques' },
          finishing: { title: 'Finishing', description: 'Every detail is perfected with precision' },
        },
        valuesTitle: 'Our Values',
        location: 'Teolo, Padova, Italy',
      },
      social: {
        followUs: 'Follow us for news and exclusive offers',
      },
      chat: {
        needHelp: 'Need help?',
        chatWithUs: 'Chat with us',
        hereToHelp: "We're here to help",
      },
      footer: {
        tagline: 'Italian artisan creations inspired by nature',
        navigation: 'Navigation',
        collections: 'Collections',
        contact: 'Contact',
        newsletter: 'Newsletter',
        newsletterText: 'Subscribe to receive news and exclusive offers',
        subscribe: 'Subscribe',
        emailPlaceholder: 'Your email',
        rights: 'All rights reserved',
      },
      product: {
        notFound: 'Product not found',
        notFoundDesc: 'The product you are looking for does not exist.',
        variant: 'Variant',
        unavailable: 'Unavailable',
        addedToCart: 'Added to cart',
        madeInItaly: 'Artisan-made in Italy',
        hypoallergenic: 'Hypoallergenic - Nickel-free',
        globalShipping: 'Safe global shipping',
        noImage: 'No image',
        relatedProducts: 'You May Also Like',
      },
      notFound: {
        title: 'Page not found',
        description: 'The page you are looking for does not exist or has been moved.',
      },
      cart: {
        title: 'Cart',
        empty: 'Your cart is empty',
        itemCount_one: '{{count}} item in cart',
        itemCount_other: '{{count}} items in cart',
        removeItem: 'Remove from cart',
        decreaseQty: 'Decrease quantity',
        increaseQty: 'Increase quantity',
        creatingCheckout: 'Creating checkout...',
        giftWrap: 'Gift wrap',
        giftWrapPrice: '+€3.50',
        shippingAtCheckout: 'Shipping will be calculated at checkout',
      },
      blog: {
        label: 'Our Blog',
        title: 'Stories From Those Who Live Outside',
        subtitle: 'Mountains, hunting, horses and bronze. Tales for those who carry their world with them.',
        readMore: 'Read the full article',
        backToBlog: 'Back to Blog',
        relatedProducts: 'Related Products',
      },
      common: {
        addToCart: 'Add to Cart',
        viewProduct: 'View Product',
        price: 'Price',
        quantity: 'Quantity',
        total: 'Total',
        checkout: 'Proceed to Checkout',
        continueShopping: 'Continue Shopping',
        emptyCart: 'Your cart is empty',
        loading: 'Loading...',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
